export function validateFullName(value: string): boolean {
  if (!value) return false

  value = value.trim().replace(/\s{2,}/g, ' ')
  const [firstName, secondName] = value.split(' ')

  return Boolean(firstName && secondName)
}
